// Generated by scripts/update-seeq-icons.js from src/svg/seeq/arrow-right-chevron.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcArrowRightChevron = {
  prefix: 'fak',
  iconName: 'arrow-right-chevron' as IconName,
  icon: [
    1024,
    1024,
    [],
    '',
    'M803.8 512c0 25.6-10.2 46.1-25.6 66.6l-399.3 430c-20.5 20.5-51.2 20.5-71.7 0l-71.7-66.5c-20.5-20.5-20.5-51.2 0-71.7l337.9-363.5-337.9-363.5c-20.5-20.5-15.4-51.2 0-71.7l71.7-56.3c20.5-20.5 51.2-15.4 71.7 0l399.3 430c15.4 20.5 25.6 41 25.6 66.6z',
  ],
} satisfies IconDefinition;
